import Header from './components/Header';
import Hero from './components/Hero';
import Contact from './components/Contact';
import Features from './components/Features';
import Comments from './components/Comments';
import Cards from './components/Cards';
import Topics from './components/Topics';
import About from './components/About';
import Updates from './components/Updates';
import AppSection from './components/AppSection';
import Index from './components/Index';
import Ranking from './components/Ranking';
import FAQ from './components/FAQ';
import Media from './components/Media';
import Carousel from './components/Carousel';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Contact />
        <Features />
        <Comments />
        <Cards />
        <Topics />
        <About />
        <Updates />
        <AppSection />
        <Index />
        <Ranking />
        <FAQ />
        <Media />
        <Carousel />
      </main>
      <Footer />
    </div>
  );
}